
import React from 'react';
import { motion } from 'framer-motion';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Check, AlertCircle } from 'lucide-react';

type FormInputProps = {
  control: any;
  name: string;
  label: string;
  placeholder: string;
  required?: boolean;
  type?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  isOptional?: boolean;
};

const FormInput = ({
  control,
  name,
  label,
  placeholder,
  required = true,
  type = 'text',
  inputRef,
  isOptional = false,
}: FormInputProps) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={isOptional ? 'opacity-80 hover:opacity-100 transition-opacity duration-300' : ''}>
          <FormLabel className="text-gray-100 flex items-center">
            {label} 
            {!required && <span className="text-xs text-gray-400 ml-1">(optional)</span>}
          </FormLabel>
          <FormControl>
            <div className="relative">
              <Input 
                ref={inputRef}
                placeholder={placeholder} 
                type={type} 
                {...field} 
                className="bg-white/5 border-white/20 focus:border-[#33C3F0]/50 text-white placeholder:text-gray-400 transition-all duration-200 focus:ring-1 focus:ring-[#33C3F0]/30 hover:border-white/30 pr-10"
                aria-required={required ? "true" : "false"}
              />
              
              {/* Validation icon */}
              {field.value && (
                <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                  {fieldState.invalid ? (
                    <AlertCircle className="h-4 w-4 text-red-400" />
                  ) : (
                    <Check className="h-4 w-4 text-green-400" />
                  )}
                </div>
              )}
              
              {/* Auto-focus visual indicator */}
              {inputRef && name === 'name' && (
                <motion.div 
                  className="absolute -inset-0.5 rounded-md border border-[#33C3F0] opacity-0 pointer-events-none"
                  animate={{ opacity: [0, 0.6, 0] }}
                  transition={{ duration: 1.5, ease: "easeInOut", delay: 0.3 }}
                />
              )}
            </div>
          </FormControl>
          <FormMessage className="text-[#FF6B6B] text-xs mt-1" />
        </FormItem>
      )}
    />
  );
};

export default FormInput;
